var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHierarchicalGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3083",
    "data-name": "Groupe 3083",
    transform: "translate(-1139.667 -786.778)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_443",
    "data-name": "Trac\\xE9 443",
    d: "M1147.667,786.778a8,8,0,1,0,8,8A8,8,0,0,0,1147.667,786.778Zm0,14.273a6.273,6.273,0,1,1,6.273-6.273A6.281,6.281,0,0,1,1147.667,801.051Z",
    fill: "#05d5e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_444",
    "data-name": "Trac\\xE9 444",
    d: "M1176.631,819.155a4.587,4.587,0,1,0,4.587,4.587A4.592,4.592,0,0,0,1176.631,819.155Zm0,7.173a2.586,2.586,0,1,1,2.586-2.586A2.589,2.589,0,0,1,1176.631,826.328Z",
    transform: "translate(-28.964 -28.964)",
    fill: "#05d5e3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHierarchicalGroup);
export default __webpack_public_path__ + "static/media/hierarchical-group.d5550a3c394b4c41cad7d5d88fb9f05f.svg";
export { ForwardRef as ReactComponent };